<div class="time-picker-card">
  <div class="title">Select Time, please</div>

  <div class="time-picker-container">
    <!-- Scroll Buttons (Up and Down) on Left and Right -->
    <div class="scroll-buttons-container">
      <button (click)="scrollUp()" class="scroll-button-left">
        <i class="fa-solid fa-arrow-up custom-icon-color" style="margin-right: 8px;"></i>
        Up
      </button>
      <button (click)="scrollDown()" class="scroll-button-right">
        <i class="fa-solid fa-arrow-down custom-icon-color" style="margin-right: 8px;"></i>
        Down
      </button>
    </div>

    <!-- Time Picker -->
    <div
      class="scroll-container"
      #timeRef
      (scroll)="onScroll()"
      (mousedown)="startDrag($event)"
      (mouseup)="endDrag()"
      (mouseleave)="endDrag()"
      (touchstart)="startDrag($event)"
      (touchend)="endDrag()"
    >
      <div class="spacer"></div>
      <div
        *ngFor="let time of timeArray; let i = index"
        [class.selected]="selectedTimeIndex === i"
      >
        {{ time }}
      </div>
      <div class="spacer"></div>
    </div>
  </div>

  <!-- AM/PM Toggle -->
  <!-- <div class="am-pm-container">
    <div class="indicator" [ngClass]="{ 'right': period === 'PM' }"></div>
    <button
      class="toggle-button"
      [class.active]="period === 'AM'"
      (click)="setPeriod('AM')"
    >
      AM
    </button>
    <button
      class="toggle-button"
      [class.active]="period === 'PM'"
      (click)="setPeriod('PM')"
    >
      PM
    </button>
  </div> -->

  <div
    *ngIf="isError"
    style="font-size: 10px; text-align: center; color: red; margin-top: 10px; font-weight: 600; margin-bottom: 10px; margin-left: 20px; margin-right: 20px;"
  >
    Selected time is not available. Please select another time.
  </div>

  <!-- Submit Button -->
  <div class="submit-container">
    <button (click)="submitTime()" class="submit-container-button">Submit</button>
  </div>
</div>
